import { Component, Input, OnInit, OnDestroy, EventEmitter, Output } from '@angular/core';
import { QuotationChangeStatusRequest, QuotationStatusMaster, QuotationSummaryUploaded } from 'src/app/_Models/quotationNew/quotationNewsummary.model';
import { UploadedDocPopupComponent } from '../uploaded-doc-popup-quotation/uploaded-doc-popup.component';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { QuotationSummaryService } from 'src/app/_Services/quotationNew/quotationsummary.service';
import { Subject, takeUntil } from 'rxjs';
import { CommonModule } from '@angular/common';
import { ToastrService } from 'ngx-toastr';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-reject-popup',
  templateUrl: './reject-popup.component.html',
  styleUrls: ['./reject-popup.component.scss']
})
export class RejectPopupComponent implements OnInit, OnDestroy {

  @Input() data!: QuotationSummaryUploaded;
  @Output() refreshdata = new EventEmitter<any>();
  
  public model: QuotationChangeStatusRequest;
  public isLoading: boolean = false;
  componentDestroyed$: Subject<boolean> = new Subject();
  public reason: string = '';

  constructor(
    public modalService: NgbModal,
    public quService: QuotationSummaryService,
    private toastr: ToastrService,
    private translate: TranslateService
  ) { }

  ngOnInit(): void {
    this.model = new QuotationChangeStatusRequest();
    this.model.quotationId = this.data.quotationId;
    this.model.statusId = QuotationStatusMaster.Rejected;
  }

  cancelClicked() {
    this.modalService.dismissAll();
    this.model.comment = this.reason;
    const modalRef = this.modalService.open(UploadedDocPopupComponent, { centered: true, windowClass: 'document-popup-wrapper certifcate-view-popup' });
    modalRef.componentInstance.data = this.data;   // pass data to popup

    modalRef.componentInstance.setPdf(this.data.quotationFileUrl);
  }

  saveRejectedQuotation() {
    // Validate reason is provided
    if (!this.reason || this.reason.trim() === '') {
      this.toastr.error(
        this.translate.instant('Please enter a reason for rejection')
      );
      return;
    }

    this.isLoading = true;
    this.model.comment = this.reason;
    this.quService.updateQuotationStatus(this.model)
      .pipe(takeUntil(this.componentDestroyed$))
      .subscribe(
        (response) => {
          this.isLoading = false;
          if (response) {
            if (response && response == 1) {
              // Show success toaster
              this.toastr.success(
                this.translate.instant('Quotation rejected successfully')
              );
            this.modalService.dismissAll();
              // Close modal and return success to refresh parent data
              // setTimeout(() => {
               
              //   // Refresh the page to show updated data
              //   window.location.reload();
              // }, 1500);
              this.refreshdata.emit();
            } else {
              this.toastr.error(
                this.translate.instant('Failed to reject quotation')
              );
            }
          }
        },
        (error) => {
          this.isLoading = false;
          this.toastr.error(
            this.translate.instant('An error occurred while rejecting the quotation')
          );
          console.error('Rejection error:', error);
        }
      );
  }

  ngOnDestroy(): void {
    this.componentDestroyed$.next(true);
    this.componentDestroyed$.complete();
  }
}
